import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { addEventListener, removeEventListener } from 'Lib/utils/mediaQueryListener';

import { LAYOUT_DESKTOP, LAYOUT_MOBILE, layoutChanged } from 'Store/commonActions';

import { mobileDesktopBreakpointQuery } from 'Components/MediaQuery';

const useLayoutChange = () => {
  const dispatch = useDispatch();
  // fired when window is resized from desktop to mobile layout and vice versa
  const handleLayoutChange = useCallback(
    (mediaQueryList) => {
      const newLayout = mediaQueryList.matches ? LAYOUT_DESKTOP : LAYOUT_MOBILE;
      dispatch(layoutChanged(newLayout));
    },
    [dispatch]
  );

  useEffect(() => {
    addEventListener(mobileDesktopBreakpointQuery, handleLayoutChange);
    handleLayoutChange(mobileDesktopBreakpointQuery);

    return () => {
      removeEventListener(mobileDesktopBreakpointQuery, handleLayoutChange);
    };
  }, [handleLayoutChange]);
};

export default useLayoutChange;
